import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import { CHART_SERIES_COLOR_MAP } from 'constants/colorMaps'
import DonutChart from 'components/Shared/charts/DonutChart'

const StyledWrapper = styled.div`
  display: flex;
  flex: initial;
  width: 188px;
  flex-direction: column;
  padding: 0;
  border-radius: 3px;
  background-color: #FFFFFF;
`

const ChartWrapper = styled.div`
  height: 160px;
  flex: 1;
`

const CreatedClosedTicketsPieChart = ({ recentNewTicketsCount, recentClosedTicketsCount }) => {
  const { t } = useTranslation()

  const data = [
    { name: t('dashboardPage.created'), color: CHART_SERIES_COLOR_MAP['new'], y: recentNewTicketsCount },
    { name: t('dashboardPage.closed'), color: CHART_SERIES_COLOR_MAP['closed'], y: recentClosedTicketsCount },
  ]

  return (
    <StyledWrapper>
      <ChartWrapper>
        <DonutChart data={data} />
      </ChartWrapper>
    </StyledWrapper>
  )
}

CreatedClosedTicketsPieChart.propTypes = {
  recentNewTicketsCount: PropTypes.number,
  recentClosedTicketsCount: PropTypes.number,
}

export default CreatedClosedTicketsPieChart
